module.exports = __webpack_public_path__ + "images/icon_bet_plus_wca_1dfa700c8c61b51d6583e553a572422f.svg";